import React from 'react'
import { StandardLink } from './StandardLink'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const StandardListElm = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: .5rem;
  max-width: ${props => props.theme.maxPageContentWidth};
`

const StandardListLabel = styled.div`
  padding: .5rem;
`

export const StandardList = ({ standards }) => {
  const targetArray = Array.isArray(standards) ? standards : []

  const codes = targetArray.reduce((acc, item) => {
    if (typeof item === 'string') {
      acc.push({ code: item, label: null })
    } else {
      acc.push({
        label: item.frontmatter.title,
        code: item.fields.code
      })
    }
    return acc
  }, [])
  const standardList = codes.map(({ label, code }) => (<StandardLink key={`${code}`} label={label} code={code} />))
  const standardsExist = standardList && standardList.length > 0
  return standardsExist ? (
    <StandardListElm>
      <StandardListLabel>GSE Standards:</StandardListLabel>
      <div>{standardList}</div>
    </StandardListElm>
  ) : (
    null
  )
}

StandardList.propTypes = {
  standards: PropTypes.array
}
